import querystring from 'querystring';
import _, { parseInt } from 'lodash';
import ApiService from '../api/ApiService';
import { Auth } from '../../config/configuration/react';

let called = false;
const getApiResponse = async (route, params) => {
  const listParam = ['liter', 'kw', 'fiscal', 'engine', 'gearId', 'seats', 'doors', 'fuelId', 'bodyId'];
  for (let i = 0; i <= listParam.length; i++) {
    if (params[listParam[i]]) {
      const _params = params;
      delete _params[listParam[i]];
      try {
        /* eslint-disable no-await-in-loop */
        const res = await ApiService('getListFromReferential', route, _params);
        return res;
      } catch {
        called = false;
        console.log('error getListFromReferential');
      }
    }
  }
  return null;
};

export default async function getListFromReferential(filters, search) {
  let { makeId, modelId } = filters;
  const { kw } = filters;
  const { dateOfRelease, engineId, doorId, liter } = filters;
  if (parseInt(makeId, 10) === 0) makeId = undefined;
  if (parseInt(modelId, 10) === 0) modelId = undefined;

  let parameters = '';
  const apiFilters = { ...filters };
  delete apiFilters.kw;

  if (makeId !== undefined) {
    parameters += `make/${makeId}`;
  }

  if (modelId !== undefined) {
    parameters += `/model/${modelId}`;
  }

  if (search === 'makes' && makeId !== undefined) {
    parameters = `make/${makeId}`;
  }

  if (search === 'models' && makeId !== undefined) {
    parameters = `make/${makeId}`;
  }

  let route = `/${parameters}/${search}`;

  switch (search) {
    case 'makes':
      route = '/makes';
      break;
    case 'fuels':
      delete apiFilters.fuelId;
      break;
    case 'bodies':
      delete apiFilters.bodyId;
      break;
    case 'doors':
      delete apiFilters.doorId;
      break;
    case 'gears':
      delete apiFilters.gearId;
      break;
    case 'seats':
      delete apiFilters.seats;
      break;
    case 'engines':
      if (kw !== null) {
        apiFilters.kw = parseInt(kw, 10);
      }
      break;
    case 'cylinders':
      delete apiFilters.cylinders;
      break;
    case 'versions':
      if (kw !== null) {
        apiFilters.kw = parseInt(kw, 10);
      }
      if (liter) {
        apiFilters.literList = liter;
        delete apiFilters.liter;
      }
      break;
    default:
      break;
  }

  if (dateOfRelease && typeof dateOfRelease === 'string') {
    delete apiFilters.dateOfRelease;
    const year = _.parseInt(dateOfRelease.substring(0, 4), 10);
    if (_.inRange(year, 1970, new Date().getFullYear())) {
      apiFilters.year = year;
    }
    const month = dateOfRelease.substring(5, 7);
    if (month && month.length === 2) {
      apiFilters.month = month;
    }
  }

  if (engineId) {
    delete apiFilters.engineId;
    apiFilters.engine = engineId;
  }
  if (doorId) {
    delete apiFilters.doorId;
    apiFilters.doors = doorId;
  }
  delete apiFilters.makeId;
  delete apiFilters.modelId;

  apiFilters.country = Auth.country();
  apiFilters.origin = 'autobizCarcheck';
  // if (search === 'versions') apiFilters.regOk = false;
  const REG_OK_FALSE_SEARCHES = [
    'makes',
    'models',
    'fuels',
    'bodies',
    'doors',
    'seats',
    'gears',
    'engines',
    'cylinders',
    'versions',
  ];
  if (REG_OK_FALSE_SEARCHES.includes(search)) {
    apiFilters.regOk = false;
  }

  let params = querystring.stringify(apiFilters);

  let result;

  try {
    if (called) return false;
    called = true;
    result = await ApiService('getListFromReferential', route, querystring.parse(params));
  } catch {
    params = querystring.parse(params);
    result = await getApiResponse(route, params);
  }
  called = false;
  if (Array.isArray(result.data)) return result.data;
  return [result.data];
}
